function oobleAR(key) {
  let mvId;
  if (key === 'mini') {
    mvId = 'mv-mini';
  } else if (key === '13') {
    mvId = 'mv-13';
  } else if (key === 'mini_black') {
    mvId = 'mv-mini-black';
  } else {
    mvId = 'mv-13-black';
  }
  const mv = document.getElementById(mvId);
  if (mv && mv.canActivateAR) {
    mv.activateAR();
  } else {
    alert('ARはスマホ（iPhone / Android）で開くとご利用いただけます。');
  }
}

document.querySelectorAll('.js-tab__nav').forEach(function(nav, index) {
  nav.addEventListener('click', function() {
    document.querySelectorAll('.js-tab__nav').forEach(function(el) {
      el.classList.remove('js-active');
    });
    document.querySelectorAll('.js-tab__content').forEach(function(el) {
      el.classList.remove('js-active');
    });

    this.classList.add('js-active');
    document.querySelectorAll('.js-tab__content')[index].classList.add('js-active');
  });
});